// Third party
import isFunction from "lodash/fp/isFunction";

/**
 * Executes the postFn with mailboxAddress and draft identities.
 *
 * @param {Function} postFn - Function which accepts a URI and body object and then returns a Promise.
 * @param {String} mailboxAddress - Mailbox to query.
 * @param {Array} draftIdentities - Draft identities to delete.
 * @return {Promise.<MailboxDraft>}
 */
function postDeleteDrafts(postFn, mailboxAddress, draftIdentities) {
  return mailboxAddress && draftIdentities ?
    postFn(`api/mailbox/${mailboxAddress}/drafts/delete`, { draftIdentities })
      .then(response => response.json()) :
    Promise.reject(new Error("Mailbox address and draft identities are required"));
}

/**
 * Creates a function which will request drafts are deleted.
 *
 * @param {Function} postFn - Function which accepts a URI and body object and then returns a Promise.
 * @return {Function} Function which requests drafts are deleted when executed with a mailbox address and some
 * draft identities and returns a Promise containing the API response.
 */
function createDeleteDraftsRequest(postFn) {
  const hasPostFn = postFn && isFunction(postFn);

  return (mailboxAddress, draftIdentities) => (hasPostFn ?
    postDeleteDrafts(postFn, mailboxAddress, draftIdentities) :
    Promise.reject(new Error("HTTP POST function is required but was not provided")));
}

export default createDeleteDraftsRequest;
